require('../../../core/frontend/vendor_modules/jquery-2.1.4.js');

$.extend($.fn, {
  setCursorPosition: (function(pos) {
    var elem, range;
    if (this.length > 0) {
      elem = this.get(0);
      if (elem != null) {
        if (elem.setSelectionRange != null) {
          return elem.setSelectionRange(pos, pos);
        } else if (elem.createTextRange != null) {
          range = elem.createTextRange();
          range.collapse(true);
          range.moveEnd('character', pos);
          range.moveStart('character', pos);
          return range.select();
        }
      }
    }
  }),
  placeholderInput: (function() {
    var inputField, nativePlaceholder;
    inputField = $(this);
    nativePlaceholder = document.createElement('input').placeholder !== void 0 && navigator.appVersion.indexOf("MSIE") === -1;
    if (!nativePlaceholder && (inputField.attr('placeholder') != null)) {
      inputField.keypress(function() {
        if ($(this).val() === $(this).attr('placeholder')) {
          $(this).css({
            color: '#333333'
          });
          return $(this).val('');
        }
      });
      inputField.keyup(function() {
        if ($(this).val() !== '') {
          if ($(this).val() !== $(this).attr('placeholder')) {
            return $(this).css({
              color: '#333333'
            });
          }
        } else {
          $(this).css({
            color: '#888888'
          });
          $(this).val(inputField.attr('placeholder'));
          return $(this).setCursorPosition(0);
        }
      });
      if (inputField.val() === '') {
        inputField.css({
          color: '#888888'
        });
        inputField.val(inputField.attr('placeholder'));
        return inputField.setCursorPosition(0);
      }
    }
  })
});

//# sourceMappingURL=data:application/json;base64,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
